import React from "react";
import { useTranslation } from "react-i18next";
import PathLink from "../../shared/seo/PathLink";
import { urls, copy } from "../../shared/seo/links";
import "./lawyers.css";

// Links from a governorate to its cassation / appeal / trainee listings.
export default function LawyerLevelFilter({ lang, governorate, barLevel }) {
  const { t } = useTranslation();
  if (!governorate) return null;
  const levels = [...urls.BAR_LEVELS].sort((a, b) => b.key - a.key);
  return (
    <nav className="avc-level-filter" aria-label={t("lawyers_level_label")}>
      <PathLink
        to={urls.lawyersPath(lang, { governorate })}
        className={"avc-level-chip" + (!barLevel ? " is-current" : "")}
        aria-current={!barLevel ? "page" : undefined}
      >
        {t("lawyers_all_levels")}
      </PathLink>
      {levels.map((level) => {
        const current = barLevel && barLevel.key === level.key;
        return (
          <PathLink
            key={level.key}
            to={urls.lawyersPath(lang, { governorate, barLevel: level })}
            className={"avc-level-chip" + (current ? " is-current" : "")}
            aria-current={current ? "page" : undefined}
          >
            {copy.lawyers(lang, { governorate, barLevel: level }).h1}
          </PathLink>
        );
      })}
    </nav>
  );
}
